import Box from "@material-ui/core/Box";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import React from "react";
import All from "../Gallery/All";
import AmenitiesGall from "../Gallery/AmenitiesGall";
import Elevation from "../Gallery/Elevation";
import Interior from "../Gallery/Interior";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      style={{ padding: 0 }} // Remove default padding
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#4A225B",
    height: "4px",
  },
})((props) => <Tabs {...props} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#666666",
    fontSize: "1.125rem",
    "&:focus": {
      color: "#693471",
    },
  },
}))((props) => (
  <Tab
    disableRipple
    {...props}
  />
));

const useStyles = makeStyles((theme) => ({
  heading: {
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  gg: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
    width: "100%",
    padding: "0rem 8rem 0rem 8rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "0.5rem",
      margin: "0rem 0rem 1rem 0rem",
    },
    // [theme.breakpoints.down("lg")]: {
    //   padding: "0rem 2rem 0rem 2rem",
    // },
  },
  tabContent: {
    padding: "2.5rem 8rem 2.5rem 8rem",
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  sectionContainer: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
}));

const GallerySection = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.sectionContainer}>
      <div className={classes.gg}>
        <Typography
          className={classes.heading}
          component="span"
        >
          Gallery
        </Typography>
        <StyledTabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          centered
        >
          <StyledTab
            label="All"
            {...a11yProps(0)}
          />
          <StyledTab
            label="Elevation"
            {...a11yProps(1)}
          />
          <StyledTab
            label="Interior"
            {...a11yProps(2)}
          />
          <StyledTab
            label="Amenities"
            {...a11yProps(3)}
          />
        </StyledTabs>
      </div>
      <div className={classes.tabContent}>
        <TabPanel
          value={value}
          index={0}
        >
          <All />
        </TabPanel>
        <TabPanel
          value={value}
          index={1}
        >
          <Elevation />
        </TabPanel>
        <TabPanel
          value={value}
          index={2}
        >
          <Interior />
        </TabPanel>
        <TabPanel
          value={value}
          index={3}
        >
          <AmenitiesGall />
        </TabPanel>
      </div>
    </div>
  );
};

export default GallerySection;
